import { PageWithPath } from 'types';
import RelatedContent from '~/components/tiles/related-content';
import TileRow from '~/components/tile-row';
import styles from '~/styles/components/page-components/content.module.scss';

export default function Content({
  pages,
  title = 'Related content',
}: {
  pages: PageWithPath[];
  title?: string;
}) {
  console.log('Content component received pages:', pages.length);
  console.table(
    pages.map((p) => ({ path: p.path, title: p.displayTitle || p.meta?.title }))
  );

  if (!pages?.length) {
    return null;
  }

  function renderContent() {
    return pages?.map((page) => <RelatedContent key={page.path} page={page} />);
  }

  return (
    <div className={styles['content']}>
      <TileRow title={title} tileStyle="content">
        {renderContent()}
      </TileRow>
    </div>
  );
}
